export function normalizeMojibake(text) {
  if (!text || !/Ã.|â.|ðŸ|�/.test(text)) {
    return text;
  }

  try {
    return decodeURIComponent(escape(text));
  } catch (error) {
    return text;
  }
}

export function normalizeEntry(entry) {
  if (!entry) {
    return entry;
  }

  return {
    ...entry,
    title: normalizeMojibake(entry.title),
    summary: normalizeMojibake(entry.summary),
    body: normalizeMojibake(entry.body),
    category: normalizeMojibake(entry.category)
  };
}
